import '@fontsource-variable/fraunces/index.css'
import '@fontsource-variable/fraunces/standard-italic.css'
import '@fontsource-variable/inter/index.css'

import axios from 'axios'
import { createInertiaApp } from '@inertiajs/react'

// Rails verifies the X-CSRF-Token header. Our ApplicationController refreshes an
// XSRF-TOKEN cookie on every response; tell axios (which Inertia uses) to read
// that cookie and send it under the header name Rails expects.
axios.defaults.xsrfHeaderName = 'X-CSRF-Token'
axios.defaults.xsrfCookieName = 'XSRF-TOKEN'

void createInertiaApp({
  pages: "../pages",

  strictMode: true,

  defaults: {
    form: {
      forceIndicesArrayFormatInFormData: false,
      withAllErrors: true,
    },
    visitOptions: () => {
      return { queryStringArrayFormat: "brackets" }
    },
  },
}).catch((error) => {
  // This ensures this entrypoint is only loaded on Inertia pages
  // by checking for the presence of the root element (#app by default).
  // Feel free to remove this `catch` if you don't need it.
  if (document.getElementById("app")) {
    throw error
  } else {
    console.error(
      "Missing root element.\n\n" +
      "If you see this error, it probably means you loaded Inertia.js on non-Inertia pages.\n" +
      'Consider moving <%= vite_typescript_tag "inertia.tsx" %> to the Inertia-specific layout instead.',
    )
  }
})
